<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 321.1 210.9"
    >
      <g>
        <g>
          <g>
            <path
              :fill="iconColor"
              d="M321,145.9c-0.8-18.4-4-38.8-8.8-58c-4.8-18.4-10.8-35.6-18-48.8c-28-49.2-58.4-41.6-94.8-32
              c-11.6,2.8-24,6-36.8,7.2h-4c-12.8-1.2-25.2-4.4-36.8-7.2C85.4-2.1,55-10.1,27,39.5C19.8,52.7,13.4,69.9,9,88.3
              c-4.8,19.2-8,39.6-8.8,58c-0.8,20.4,1.2,35.2,5.6,45.6c4.4,9.6,10.8,15.6,19.2,18c7.6,2,16.4,1.2,25.6-2.8
              c15.6-6.4,33.6-20,51.2-36.4c12.4-12,35.6-18,58.8-18s46.4,6,58.8,18c17.6,16.4,35.6,30,51.2,36.4c9.2,3.6,18,4.8,25.6,2.8
              c8-2.4,14.8-8,19.2-18.4C319.8,181.5,321.8,166.7,321,145.9z M301.8,185.9c-2.4,5.6-5.6,8.8-9.6,10c-4.4,1.2-10,0.4-16.4-2
              c-14-5.6-30.4-18-46.4-33.2c-15.2-15.2-42-22.8-68.8-22.8s-53.6,7.6-69.2,22c-16.4,15.2-32.8,28-46.4,33.2
              c-6.4,2.4-12,3.6-16.4,2c-4-1.2-7.2-4.4-9.6-10c-3.2-7.6-4.8-20-4-38.4c0.8-17.2,3.6-36.8,8.4-55.2c4.4-17.2,10-33.2,16.8-45.2
              c22-39.6,47.6-33.2,78-25.2c12.4,3.2,25.2,6.4,39.2,7.6c0.4,0,0.4,0,0.8,0h4.4c0.4,0,0.4,0,0.8,0c14.4-1.2,27.2-4.4,39.6-7.6
              c30.4-7.6,56-14.4,78,25.2c6.8,12,12.4,27.6,16.8,45.2c4.4,18.4,7.6,37.6,8.4,55.2C307,165.1,305.4,177.5,301.8,185.9z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              :fill="iconColor"
              d="M123.8,67.9c-4-3.6-8.8-6.4-14.4-6.8c-0.4-5.2-2.8-10.4-6.4-14l-0.4-0.4c-4.4-4.4-10-6.8-16.4-6.8
              s-12.4,2.8-16.4,6.8c-3.6,3.6-6.4,8.8-6.8,14.4c-5.6,0.4-10.4,2.8-14.4,6.4l-0.4,0.4c-4.4,4.4-6.8,10-6.8,16.4s2.8,12.4,6.8,16.4
              s8.8,6.4,14.8,6.8c0.4,5.6,2.8,10.8,6.8,14.4c4.4,4.4,10,6.8,16.4,6.8s12.4-2.8,16.4-6.8c3.6-4,6.4-8.8,6.8-14.4
              c5.6-0.4,10.8-2.8,14.4-6.8c4.4-4.4,6.8-10,6.8-16.4S127.8,71.9,123.8,67.9z M113.8,90.3c-1.6,1.6-3.6,2.4-6,2.4h-5.6
              c-4,0-7.6,3.2-7.6,7.6v5.2c0,2.4-0.8,4.4-2.4,6s-3.6,2.4-6,2.4s-4.4-0.8-6-2.4c-1.6-1.6-2.4-3.6-2.4-6v-5.6c0-4-3.2-7.6-7.6-7.6
              h-5.6c-2.4,0-4.4-0.8-6-2.4c-1.2-1.2-2.4-3.2-2.4-5.6c0-2.4,0.8-4.4,2.4-6c0,0,0,0,0.4-0.4c1.6-1.2,3.6-2,5.6-2h5.6
              c4,0,7.6-3.2,7.6-7.6v-5.6c0-2.4,0.8-4.4,2.4-6s3.6-2.4,6-2.4s4.4,0.8,6,2.4c0,0,0,0,0.4,0.4c1.2,1.6,2,3.6,2,5.6v5.6
              c0,4,3.2,7.6,7.6,7.6h5.6c2.4,0,4.4,0.8,6,2.4c1.6,1.6,2.4,3.6,2.4,6C116.2,86.7,115.4,88.7,113.8,90.3z"
            />
          </g>
        </g>
        <g>
          <g>
            <circle :fill="iconColor" cx="230.2" cy="55.9" r="14" />
          </g>
        </g>
        <g>
          <g>
            <circle :fill="iconColor" cx="230.2" cy="112.7" r="14" />
          </g>
        </g>
        <g>
          <g>
            <circle :fill="iconColor" cx="201.8" cy="84.3" r="14" />
          </g>
        </g>
        <g>
          <g>
            <circle :fill="iconColor" cx="258.6" cy="84.3" r="14" />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "GameZoneIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
